import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import './NavBar.module.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { Services } from '@/services/services';
import { Layout } from '@/services/layout/layout';
import { Translates } from '@/services/repository/i18n';
import { useLogin } from '@/context/login';
import { Spinner } from '../spinner';
import { goBack } from '@/common/reactnav';


// BackButton always steps back in history; fallbackUrl is used only when there is
// no previous in-app page (e.g. the page was opened from a QR code or a link).
export const BackButton = ({ services, translates, fallbackUrl }: { services: Services, translates: Translates | undefined, fallbackUrl?: string }) => {
  const navigate = useNavigate()

  const handleGoBack = () => {
    goBack(navigate, fallbackUrl)
  }

  if(translates===undefined) {
    return <div className='spinner'></div>
  }

  return <div className='navbar-back-btn' onClick={handleGoBack}>
    <i className='svgfont-back' />
    <div className='text'>
      {translates.for('layout.navbar.back')}
    </div>
  </div>
}


export const LoginButton = ({ translates }: { translates: Translates }) => {
  const { redirectToLogin } = useLogin()

  const goToLogin = () => {
    redirectToLogin({
      redirectTo: window.location.pathname + window.location.search + window.location.hash
    })
  }

  return <div className='navbar-login-btn' onClick={goToLogin}>
    <div className='text'>
      {translates.for('layout.navbar.login')}
    </div>
  </div>
}

export const LogoutButton = ({ services, translates }: { services: Services, translates: Translates }) => {
  const navigate = useNavigate()
  return <div className='navbar-logout-btn' onClick={() => navigate('/logout')}>
    <img className='icon' src='/public/img/icons/field-user.svg' />
    <div className='text'>
      {translates.for('layout.navbar.logout')}
    </div>
  </div>
}

export const NavBar = ({ services }: { services: Services }) => {
  const navigate = useNavigate()
  const location = useLocation()
  let lang = useParams().lang
  const [layoutData, setLayoutData] = useState<Layout | null>(null)
  const [translates, setTranslates] = useState<Translates>()
  const [langCode, setLangCode] = useState<string>(services.i18n.defaultLang())

  useEffect(() => {
    services.i18n.get('main').then(setTranslates)
  }, [langCode])

  // useEffect(() => {
  //   let id = services.layoutHub.listen((data: Layout | null) => {
  //     console.log('setModel(data)', data)
  //     setLayoutData(data)
  //   })
  //   return () => {
  //     services.layoutHub.remove(id)
  //   };
  // }, []);

  function redirect(url: string, external: boolean) {
    if (!external) {
      navigate(url)
      return
    }
    window.location.href = url
  }

  function li(title: string, url: string, external: boolean = false) {
    return <li onClick={() => redirect(url, external)} className={location.pathname === url ? 'current' : ''}>
      <div className='wrap'>
        {title}
        <i className='svgfont-arrow-down arrow'></i>
      </div>
    </li>
  }

  function langRow(title: string, code: string) {
    return <li key={code} onClick={() => {
      services.i18n.setDefaultLang(code)
      // setLangCode(code)
      window.location.reload();
    }} className={langCode === code ? 'current' : ''}>
      <div className='wrap'>
        {title}
        <i className='svgfont-arrow-down arrow'></i>
      </div>
    </li>
  }

  if (!translates) {
    return <Spinner />
  }

  return (
    <nav className='dashboard-navbar'>
      <div className='navbar-body'>
        <ul>
          {services.i18n.languages().map((lang) => langRow(translates.for('dicts.langs.' + lang), lang))}
        </ul>
      </div>
    </nav>
  )
};
